module.exports = __webpack_public_path__ + "media/images/real-dobrepole-2edd2f2831c8762e1893fa59006dfaf0.png";